import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GeneralService } from 'src/app/shared/services/general.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AbstractForm } from '../../utils/abstract-form';
import { LoggerService } from 'src/app/core/logger/logger.service';
import { PostsService } from './posts.service';
import { Subscription } from 'rxjs';

declare var Quill: any;

@Component({
    selector: 'postsCompoment',
    templateUrl: './posts.component.html',
    styleUrls: ['./posts.component.scss']
})
export class PostsComponent extends AbstractForm implements OnInit, OnDestroy {

    dialogRef: MatDialogRef<any>;

    formGroup: FormGroup;
    params: any = {};
    list: any = [];
    perfil = [];

    postGallery = [];

    postStatusFiltered = [];

    postId: any = 'new';
    ownerId: any = null;

    tabActive = 'content';

    loading = true;

    step = 0;

    editorIndex = 0;

    quill = null;

    imageSlotSel = null;

    ScriptStore: any[] = [
        { name: 'quill', src: 'https://cdn.quilljs.com/1.3.6/quill.js' }
    ];

    private scripts: any = {};
    protected gallerySelectingSubscription: Subscription;

    constructor(

        @Inject(MAT_DIALOG_DATA) public data,
        protected formBuilder: FormBuilder,
        public ps: PostsService,
        protected gs: GeneralService,
        public dialog: MatDialog,
        logger: LoggerService
    ) {

        super(formBuilder, logger, true);

        this.postId = this.data.params.id;

        this.ownerId = this.gs.getCompanieSel();

    }

    async ngOnInit() {
        //<link href="https://cdn.quilljs.com/1.3.6/quill.snow.css" rel="stylesheet">
        this.ScriptStore.forEach((script: any) => {
            this.scripts[script.name] = {
                loaded: false,
                src: script.src
            };
        });

        this.setControlValue('type_id', this.ps.postTypes[0]);

        this.postStatusFiltered = this.ps.postStatus.filter(item => !item?.hide);

        if (this.postId != 'new') {
            this.nextStep();
        } else {
            this.step = 1;
            this.loading = false;
        }

        this.gallerySelectingSubscription = this.gs.transactionData.subscribe(result => {
            if (result?.action == 'gallerySelecting')
                if (this.imageSlotSel == 'cover') {
                    this.setControlValue('cover', result.data.thumb);
                } else if (this.imageSlotSel == 'quill') {
                    this.quill.insertEmbed(this.editorIndex, 'image', result.data.large);
                }
        });

    }

    ngOnDestroy() {
        this.gallerySelectingSubscription?.unsubscribe();
    }


    buildFormGroup(): FormGroup {

        return this.formBuilder.group({
            title: ['', [Validators.required, Validators.minLength(3)]],
            date: [new Date(), [Validators.required, Validators.minLength(3)]],
            text: [''],
            source: [''],
            meta_description: [''],
            meta_keywords: [''],
            status: ['1', [Validators.required]],
            type_id: [null, [Validators.required]],
            cover: [null]
        });
    }


    updateControls() { }
    updateObject(): any { }

    setTabActive(tab) {
        this.tabActive = tab;
    }

    async nextStep() {

        if (this.postId != 'new') {
            let data = await this.ps.loadPost(this.postId);

            if (data?.settings) {
                data = { ...data, ...JSON.parse(data.settings) };
            }

            this.postGallery = (JSON.parse(data.files) || []).map(item => { item.file_id = item.id; return item; });

            this.setFormValues(data);
        } else {
            let r: any = await this.ps.save({
                title: this.getControlValue('title'),
                type_id: this.getControlValue('type_id')?.post_type_id,
            },
                this.data.params.site_public_idtext);


            this.loading = false;

            if (!r?.id)
                return;

            this.postId = r.id;

        }
        this.loading = false;

        this.step = 2;

        this.load('quill').then(data => {
            //console.log('script loaded ', data);

            let toolbarOptions = [
                ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                //['blockquote', 'code-block'],

                [{ 'header': 1 }, { 'header': 2 }],               // custom button values
                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
                [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
                //[{ 'direction': 'rtl' }],                         // text direction

                [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
                [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

                [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                //[{ 'font': [] }],
                [{ 'align': [] }],

                ['link', 'image'],

                ['clean']                                         // remove formatting button
            ];

            this.quill = new Quill('#editor', {
                theme: 'snow',
                modules: {
                    toolbar: toolbarOptions
                }
            });

            let toolbar = this.quill.getModule('toolbar');
            toolbar.addHandler('image', (a, b, c, d) => {
                this.editorIndex = this.quill.getSelection()?.index ?? 0
                this.selImage(null, 'quill');
            });

        }).catch(error => console.log(error));
    }

    closeModal(reload = false) {
        if (reload)
            this.gs.transactionData.next({ action: 'postsReload' });

        this.dialogRef.close();
    }

    async save(e) {
        if (!e.submitter?.classList?.contains('btnSavePost')) {
            console.log(e);
            return;
        }

        if (this.formGroup.invalid)
            return;

        this.setControlValue('text', this.quill.root.innerHTML);

        let data = this.getFormValues();

        if (data.date instanceof Date)
            data.date = data.date.toISOString().substr(0, 10);

        data.status = data.status?.id || data.status;

        if (data.type_id?.post_type_id)
            data.type_id = data.type_id.post_type_id;

        if (data?.meta_description || data?.meta_keywords) {
            data.settings = {
                meta_description: data.meta_description,
                meta_keywords: data.meta_keywords
            };

            delete data.meta_description;
            delete data.meta_keywords;
        }

        if (this.postId == 'new')
            return await this.ps.save(data, this.data.params.site_public_idtext)
                .then(r => this.closeModal(true));

        return await this.ps.update({ public_idtext: this.postId, ...data })
            .then(r => this.closeModal(true));
    }

    async delete() {
        await this.ps.delete(this.postId)
            .then(r => this.closeModal(true));
    }


    compareFn(c1: any, c2: any): boolean {
        if (c2 === null)
            return false;

        return c1?.id == c2?.id || c1?.id == c2 || c1 == c2?.id;
    }


    selImage(e, slot) {
        let person_id = this.gs.getCompanieSel();
        this.imageSlotSel = slot;
        this.gs.navigate(['openModal', 'GalleryComponent'], { queryParams: { person_id: person_id } });
    }



    load(...scripts: string[]) {
        var promises: any[] = [];
        scripts.forEach((script) => promises.push(this.loadScript(script)));
        return Promise.all(promises);
    }

    loadScript(name: string) {
        return new Promise((resolve, reject) => {
            //resolve if already loaded
            if (this.scripts[name].loaded) {
                resolve({ script: name, loaded: true, status: 'Already Loaded' });
            }
            else {
                //load script
                let script: any = document.createElement('script');
                script.type = 'text/javascript';
                script.src = this.scripts[name].src;
                if (script.readyState) {  //IE
                    script.onreadystatechange = () => {
                        if (script.readyState === "loaded" || script.readyState === "complete") {
                            script.onreadystatechange = null;
                            this.scripts[name].loaded = true;
                            resolve({ script: name, loaded: true, status: 'Loaded' });
                        }
                    };
                } else {  //Others
                    script.onload = () => {
                        this.scripts[name].loaded = true;
                        resolve({ script: name, loaded: true, status: 'Loaded' });
                    };
                }
                script.onerror = (error: any) => resolve({ script: name, loaded: false, status: 'Loaded' });
                document.getElementsByTagName('head')[0].appendChild(script);
            }
        });
    }

}
